import axios from "axios";

export function getClassPerson(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ClassPerson/centerperiod", config);
}
